import { render, staticRenderFns } from "./CreateBtn.vue?vue&type=template&id=9a688242&"
import script from "./CreateBtn.vue?vue&type=script&lang=js&"
export * from "./CreateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports